/*=========================================================================================
  File Name: mutations.js
  Description: Vuex Store - mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

/* eslint-disable no-unused-vars */

import app from '@/main';
import { log } from "@/utils/logs";

// Boilerplate for generic mutations use in almost any module
// import * as generic from "@/store/generic/mutations/result-status.js";


export function setDevData (state, payload) {
  log({ name: "setDevData" }, { data: payload });
  state.developer = payload;
}

export function setDevModeOn (state) {
  state.active = true;
  // console.log(this._vm.$context);
}

export function setDevModeOff (state) {
  state.active = false;
}

export function removeDevData (state) {
  state.developer = {};
  state.active = false;
}
